import React from "react";
import { useCities } from "./useCities";
import CityMadalPopUp from "./CityModalPopUp";
import { Grid, Typography } from "@mui/material";
import DataTable from "../../../Components/Table/Table";
import { checkPermission } from "../../../Utils/Permissions";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import AddButton from "../../../Components/AddButton/AddButton";
import Paginations from "../../../Components/Pagination/Pagination";
function Cities({ isModal }) {
  const {
    locationData,
    search,
    setSearch,
    tableHeader,
    handleDelete,
    addNewCity,
    handleOpenEditPopUp,
    handleOpenPopUp,
    modal,
    setModal,
    cities,
    countries,
    platform,
    ...state
  } = useCities();

  return (
    <Grid
      sx={{
        width: "77%",
        height: "98vh",
        padding: "0px 25px",
      }}>
      <CityMadalPopUp
        setOpenModal={setModal}
        openModal={modal.isOpen}
        data={modal}
      />

      <Grid
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f9fbfc",
          borderRadius: "15px",
          padding: "20px",
        }}>
        <Grid lg={12} sx={{ height: "100px" }} container alignItems={"center"}>
          <Grid item lg={2.3}>
            <Typography
              style={{ color: "black", fontWeight: "600", fontSize: "20px" }}>
              Cities
            </Typography>
          </Grid>
          <Grid
            item
            lg={9.7}
            md={12}
            container
            justifyContent={{ md: "flex-end", lg: "space-between" }}>
            <Grid item lg={3}>
              <SearchBar
                onChagevalue={(e) =>
                  setSearch((s) => ({ ...s, keyword: e.target.value }))
                }
                width={250}
                placeHolder={"Search City,State"}
              />
            </Grid>

            <Grid mr="20px" ml="20px" item lg={2.4}>
              <DropDown
                placeHolder="All Country"
                viewHeight={"40px"}
                borderRadius={"8px"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                data={countries}
                handleSelected={(e, value) => {
                  setSearch((s) => ({
                    ...s,
                    countryIds: value?.id ? [value?.id] : [],
                  }));
                }}
              />
            </Grid>

            <Grid mb={1} item lg={1}>
              <DropDown
                placeHolder="Platform"
                viewHeight={"40px"}
                borderRadius={"8px"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                handleSelected={(e, value) => {
                  setSearch((s) => ({
                    ...s,
                    platformId: value?.id ? value?.id : [],
                  }));
                }}
                data={platform}
              />
            </Grid>

            <Grid item lg={1.7}>
              {checkPermission("DB_CITY_EDIT") && (
                <AddButton
                  labelName={"Add New City"}
                  viewHeight={"40px"}
                  borderRadius={"50px"}
                  onClick={() => handleOpenPopUp(addNewCity)}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <DataTable
          isCity={true}
          handleEdit={handleOpenEditPopUp}
          onClick={(value) => {
            checkPermission("DB_CITY_EDIT") && handleOpenEditPopUp(value);
          }}
          tableHeader={tableHeader}
          data={cities}
          handleCheckboxChange={state.handleApprovePopup}
          checkedItems={state.checkedItems}
          handleDelete={handleDelete}
          setCheckedItems={state.setCheckedItems}
          isDelete={checkPermission("DB_CITY_DELETE")}
          isApproval={checkPermission("DB_CITY_APPROVAL")}
          isEdit={checkPermission("DB_CITY_EDIT")}
        />
        <Grid
          sx={{ height: "88px", width: "100%" }}
          container
          justifyContent={"center"}
          alignItems={"center"}>
          <Paginations
            page={search.pageNo}
            count={
              locationData?.count <= 10
                ? 1
                : Math.ceil(locationData?.count / 10)
            }
            paginationData={(value) =>
              setSearch((s) => ({ ...s, pageNo: value }))
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Cities;
